module.exports = __webpack_public_path__ + "img/chat-inbox.beeba024.png";